import React from 'react';
import { RecipeText, SEORecipe } from '../components';

export default function Codfish() {
  const breadcrumbs = [
    {
      to: '/#reccats',
      title: 'Категории рецептов'
    },
    {
      to: '/ryba',
      title: 'Рыба и морепродукты'
    }
  ];

  const recipe = {
    title: 'Треска по-поморски',
    imgSrc: '/codfish.jpg',
    ingredients: [
      {
        list: ["500 г вяленой трески (см. стр. 128)", "500 мл молока", "500 г картофеля", "1/2 луковицы", "350 мл сливок", "свежемолотый чёрный перец", "соль"]
      },
    ],
    bookSrc: `Рецепт из книги Влада Пискунова <a target="_blank" rel="noopener noreferrer" href="https://www.litres.ru/vlad-piskunov/russkaya-kuhnya-luchshee-za-500-let-kniga-vtoraya-s-33399413/">«Русская кухня. Лучшее за 500 лет. Книга вторая. Супы, горячие блюда из рыбы, мяса и птицы»</a>`,
    steps: [
      {
        list: [
          'За пару суток до приготовления треску надо нарезать небольшими (30–40 г) кусками поперёк волокон. Заливаем её холодной водой — вода должна полностью покрывать рыбу — и убираем в холодильник на сутки. В течение этого времени надо дважды (а лучше ещё чаще) менять воду.',
          'На вторые сутки рыбу заливаем молоком и оставляем в холодильнике до приготовления.',
          'Достаём треску из молока и даём ему стечь.',
          'Лук нарезаем мелким кубиком, картошку — кружочками толщиной 5–6 мм.',
          'Кладём овощи и рыбу в глиняную латку, посыпаем солью и перцем. Всё аккуратно перемешиваем руками и заливаем сливками. Ещё раз перемешиваем и ставим в разогретую до 200 ºС печь примерно на полчаса.',
          'Блюдо подаём на стол горячим прямо в этой же латке. Летом можно посыпать рубленой зеленью.'
        ]
      },
    ],
    thisUrl: 'codfish'
  };
  return(
    <>
      <SEORecipe recipe={recipe} />
      <RecipeText page='ryba' recipe={recipe} breadcrumbs={breadcrumbs} />
    </>
  );
}
